import { sendAudio } from "@/Services/TherapyApi/VideoCalls";
import { hasValue } from "@/Utils/Objects";

const sendVideoCallAudioHandler = (audio: Blob, roomId: string): Promise<boolean> => {
  return sendAudio(roomId, audio)
    .then(hasValue)
    .catch(() => false);
};

export default sendVideoCallAudioHandler;
